import React from 'react';

import {withRouter} from 'react-router-dom';
import {CircularProgress} from 'material-ui/Progress';

import Snackbar from 'material-ui/Snackbar';
import MonitorinListItem from "./MonitorinListItem";
import { Button, Dialog, DialogContent, DialogTitle, DialogActions, DialogContentText } from "material-ui";
import ContextMenu from "./ContextMenu";
import {inject, observer} from "mobx-react";

class MonitoringList extends React.Component {

    state = {
        selectedItems: [],
        showDialogFinishSessions: false,
    };

    gotoMonitoringDelivery(document) {
        this.props.history.push(`/${document.id}/`);
    }

    getItems() {
        const items = this.props.items;

        return items.map((document, index) => {
            return (
                <MonitorinListItem
                    key={document.id}
                    selectedItems={this.state.selectedItems}
                    onSelectItem={this.onSelectItem}
                    gotoMonitoringDelivery={this.gotoMonitoringDelivery.bind(this)}
                    document={document}/>
            );
        });
    }

    onSelectItem = (item) => {
        const {selectedItems} = this.state;
        const currentIndex = selectedItems.indexOf(item.id);
        const newChecked = [...selectedItems];
        if (currentIndex === -1) {
            newChecked.push(item.id);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        this.setState({
            selectedItems: newChecked,
        });
    };

    selectAllItems = () => {
        const {selectedItems} = this.state;
        if (selectedItems.length === this.props.items.length) {
            this.setState({selectedItems: []});
        } else {
            const newItems = [];
            this.props.items.forEach((document) => {
                newItems.push(document.id);
            });
            this.setState({selectedItems: newItems});
        }
    };

    uncheckAll = () => {
        this.setState({selectedItems: [], showDialogFinishSessions: false});
    };

    showHideDialogFinishSessions = () => {
        this.setState({showDialogFinishSessions: !this.state.showDialogFinishSessions});
    };

    finishSessions = () => {
        const data = {
            document_ids: this.state.selectedItems,
        };

        this.props.finishSessions(data);
    };

    render() {
        const {finishing_all, error_finishing_all, items, app_store} = this.props;

        if (!this.props.is_fetched) {
            return (
                <div className="text-center" style={{marginTop: '36px'}}>
                    <div><CircularProgress/></div>
                    <p>
                        <small>Carregando...</small>
                    </p>
                </div>
            );
        }

        if (!items.length) {
            return (<div className="text-center">Nenhum documento de entrega foi encontrado.</div>);
        }

        return (
            <div className="monitoring-table-container">
                {this.state.selectedItems.length > 0 &&
                <ContextMenu
                    finishSessions={this.showHideDialogFinishSessions}
                    selectedItems={this.state.selectedItems}
                    uncheckAll={this.uncheckAll}
                />
                }
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    open={error_finishing_all}
                    autoHideDuration={4000}
                    message={'Ocorreu um problema ao finalizar as sessões. Tente novamente!'}
                />
                <Dialog open={this.state.showDialogFinishSessions}>
                    <DialogTitle>Finalizar sessões</DialogTitle>
                    <DialogContent>
                        {finishing_all ?
                            <div className={'text-center'}>
                                <CircularProgress />
                            </div>
                            :
                            <DialogContentText id="alert-dialog-description">
                                Deseja realmente finalizar as sessões selecionadas?
                            </DialogContentText>
                        }
                    </DialogContent>
                    {!finishing_all &&
                    <DialogActions>
                        <Button onClick={this.showHideDialogFinishSessions} color="default">
                            Cancelar
                        </Button>
                        <Button onClick={this.finishSessions} color="primary" autoFocus>
                            Aceitar
                        </Button>
                    </DialogActions>
                    }
                </Dialog>

                <div>
                    <Button color="primary" onClick={this.selectAllItems}>
                        <i className={'material-icons'}>check</i> Selecionar todos
                    </Button>
                </div>
                <table className="monitoring-table">
                    <thead>
                    <tr>
                        <th>Motorista</th>
                        <th>Documento</th>
                        <th>PREV. DE ENTREGA</th>
                        <th>Veículo (% tax. ocupação)</th>
                        <th>Tipo de Rota</th>
                        {
                            app_store.configurations.use_temperature && (
                                <th>Temperatura</th>
                            )
                        }
                        <th>Bateria</th>
                        <th>Entregas</th>
                        <th>Visitas</th>
                        <th>Eventos</th>
                    </tr>
                    </thead>

                    <tbody>
                    {this.getItems()}
                    </tbody>
                </table>

                <Snackbar
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                    open={this.props.fetching}
                    message={<span>Carregando...</span>}
                />
            </div>
        );
    }

}

let container = observer(MonitoringList);
container = inject(['app_store'])(container);

export default withRouter(container, {withRef: true});



// WEBPACK FOOTER //
// ./src/components/Monitoring/MonitoringList.js